<template>
    <form class="live-search-form" action="/search/search_do" method="get" @focus.capture="onFormFocus">
        <input type="hidden" name="search_types" :value="searchType"/>
        <div class="form-row justify-content-center">
            <div class="col-12">
                <div class="input-group catalog-search">
                    <input type="text" class="form-control"
                           placeholder="Поиск по каталогу товаров"
                           aria-label="Поиск по каталогу товаров"
                           @input="onInput"
                           name="search_string"
                           :value="searchInput"
                    />
                    <div class="loader" v-if="busy"><span class="bg-primary"></span><span class="bg-primary"></span><span class="bg-primary"></span></div>
                    <a class="clear-input text-danger" v-if=" searchInput.length > 0 && !busy"
                       @click.prevent="clearInput()">
                        <i class="material-icons">
                            close
                        </i>
                    </a>
                    <div class="result-list" v-if="resultListShow">
                        <div class="container">

                            <a class="row result-item py-3" :href="item.link" v-for="item in searchResult">
                                <span class="col-8 col-sm-6 text-left text-truncate">{{item.name}}</span>
                                <span class="col-sm-4 d-none d-sm-inline-block text-muted text-center">{{item.parent.name}}</span>
                                <span class="col-4 col-sm-2 font-weight-bold text-right">{{item.price}} P</span>
                            </a>

                            <div class="row result-item py-1"
                                 v-if="lastSearchResultTotal > 0 && searchInput.length > 2 && busy == false">
                                <div class="col-12">
                                    <button class="btn btn-block btn-link bg-white" type="submit">
                                        Показать все результаты
                                    </button>
                                </div>
                            </div>
                            <div class="row result-item py-3"
                                 v-if="lastSearchResultTotal == 0 && searchInput.length > 2 && busy == false">
                                <div class="col-12">
                                    Ничего не найдено
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="input-group-append">
                        <button class="btn btn-primary text-dark" type="submit" id="button-addon2">Поиск
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
  export default {
    data () {
      return {
        searchInput: '',
        busy: false,
        searchResult: [],
        lastSearchResultTotal: null,
        timeoutKeyDown: null,

        resultListShow: false,

        searchType: 56,
        perPage: 5,
      }
    },

    created () {
      document.addEventListener('click', this.onFormBlur)
    },

    destroyed () {
      document.removeEventListener('click', this.onFormBlur)
    },

    methods: {

      /**
       * Метод для показа списка результатов поиска
       */
      onFormFocus () {
        this.resultListShow = true
      },

      /**
       * Метод для скрытия списка результатов, если клик был вне формы поиска
       * @param e
       */
      onFormBlur (e) {
        if (!e.target.closest('.live-search-form')) {
          this.resultListShow = false
        }
      },

      /**
       * Метод для отправки запроса на сервер
       * @param searchString
       */
      search (searchString) {
        let vm = this

        vm.busy = true
        axios.get('/udata://search/custom_search_do/.json', {
          params: {
            search_string: vm.searchInput,
            search_types: vm.searchType,
            per_page: vm.perPage,
          },
        }).then(response => {

          vm.lastSearchResultTotal = response.data.total
          if (response.data.total > 0) {
            vm.searchResult = response.data.items.item
          }

          vm.busy = false
        })
      },

      /**
       * Метод срабатывающий при изменении поля поиска
       */
      onInput (event) {
        let vm = this

        vm.searchInput = event.target.value

        if (vm.searchInput.length > 2) {
          clearTimeout(vm.timeoutKeyDown)
          vm.timeoutKeyDown = setTimeout(function () {
            vm.searchResult = []
            vm.lastSearchResultTotal = null
            vm.search(vm.searchInput)
          }, 350)
        } else {
          vm.searchResult = []
          vm.lastSearchResultTotal = null
        }
      },

      /**
       * Метод для очистки поля поиска
       */
      clearInput () {
        this.searchInput = ''
        this.searchResult = []
        this.lastSearchResultTotal = null
      },
    },
  }
</script>
<style scoped lang="scss">
    .live-search-form input {
        box-shadow: none;
    }

    .result-list {
        display: block;
        position: absolute;

        min-width: 100%;
        height: auto;

        top: 100%;
        left: -2px;
        right: -2px;

        padding: 0;

        list-style: none;

        background-color: #fff;

        z-index: 99;

        border: 2px solid #ffc107;

        border-top-right-radius: 0;
        border-top-left-radius: 0;
        border-bottom-right-radius: 0.25em;
        border-bottom-left-radius: 0.25em;

        .result-item {

            border-bottom: 1px solid #EEEEEE;

            &:last-child {
                border-bottom: none;
            }
        }
    }

    .clear-input {
        display: block;
        position: absolute;
        height: 24px;
        top: 0;
        bottom: 0;
        margin: auto;
        right: 5rem;

        cursor: pointer;
        z-index: 999;
    }

    .loader {
        display: block;
        position: absolute;

        width: 40px;

        top: .5rem;
        right: 5rem;

        z-index: 999;

        span {
            display: inline-block;
            position: relative;

            width: 10px;
            height: 10px;

            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;

            &:first-child {
                margin-right: 5px;
            }

            &:last-child {
                margin-left: 5px;
            }

            -webkit-animation: preloader 1.4s infinite ease-in-out both;
            animation: preloader 1.4s infinite ease-in-out both;

            &:nth-child(1) {
                -webkit-animation-delay: -0.32s;
                animation-delay: -0.32s;
            }

            &:nth-child(2) {
                -webkit-animation-delay: -0.16s;
                animation-delay: -0.16s;
            }
        }

        @keyframes preloader {
            0%, 80%, 100% {
                -webkit-transform: scale(0);
                transform: scale(0);
            }
            40% {
                -webkit-transform: scale(1.0);
                transform: scale(1.0);
            }
        }
    }

</style>